(() => {
  if (window.productContactInitialized) return;
  window.productContactInitialized = true;

  const pendingStorageKey = 'spengman_product_contact_pending';

  const findProductInfoBySection = (sectionId) =>
    Array.from(document.querySelectorAll('product-info[data-section]')).find(
      (candidate) => candidate.dataset.section === sectionId
    );

  const findProductInfoByProduct = (productId) => {
    const candidates = Array.from(document.querySelectorAll('product-info[data-product-id]')).filter(
      (candidate) => candidate.dataset.productId === productId
    );
    return candidates.find((candidate) => candidate.id.startsWith('MainProduct-')) || candidates[0];
  };

  const findQuantityInput = (productInfo) =>
    productInfo?.querySelector('input.quantity__input[id^="Quantity-"][name="quantity"]');

  const updateModalVariant = (modal, variant) => {
    if (!modal || !variant) return;

    const variantTitle = variant.title === 'Default Title' ? '' : variant.title || '';
    const sku = variant.sku || '';
    const productUrl = modal.dataset.productUrl || window.location.href;
    const separator = productUrl.includes('?') ? '&' : '?';
    const variantUrl = variant.id ? `${productUrl}${separator}variant=${encodeURIComponent(variant.id)}` : productUrl;

    const variantField = modal.querySelector('[data-product-contact-variant-field]');
    const variantIdField = modal.querySelector('[data-product-contact-variant-id-field]');
    const skuField = modal.querySelector('[data-product-contact-sku-field]');
    const urlField = modal.querySelector('[data-product-contact-url-field]');
    const variantText = modal.querySelector('[data-product-contact-variant-text]');
    const variantRow = modal.querySelector('[data-product-contact-variant-row]');
    const skuText = modal.querySelector('[data-product-contact-sku-text]');
    const skuRow = modal.querySelector('[data-product-contact-sku-row]');

    if (variantField) variantField.value = variantTitle;
    if (variantIdField) variantIdField.value = variant.id || '';
    if (skuField) skuField.value = sku;
    if (urlField) urlField.value = variantUrl;
    if (variantText) variantText.textContent = variantTitle;
    if (variantRow) variantRow.hidden = !variantTitle;
    if (skuText) skuText.textContent = sku;
    if (skuRow) skuRow.hidden = !sku;
    syncModalQuantity(modal);
  };

  const syncModalQuantity = (modal) => {
    if (!modal) return;

    const directQuantityElement = document.getElementById(`Quantity-${modal.dataset.sectionId}`);
    const directQuantityInput = directQuantityElement?.matches('input[name="quantity"]')
      ? directQuantityElement
      : null;
    const sourceProductInfo = findProductInfoBySection(modal.dataset.productContactSourceSection);
    const ownedProductInfo = findProductInfoBySection(modal.dataset.sectionId);
    const fallbackProductInfo = modal.hasAttribute('data-product-contact-sync-by-product')
      ? findProductInfoByProduct(modal.dataset.productId)
      : null;
    const quantityInput =
      directQuantityInput ||
      findQuantityInput(sourceProductInfo) ||
      findQuantityInput(ownedProductInfo) ||
      findQuantityInput(fallbackProductInfo);
    const quantityField = modal.querySelector('[data-product-contact-quantity-field]');
    const quantityText = modal.querySelector('[data-product-contact-quantity-text]');
    const fallbackQuantity = quantityField?.value || '1';
    const quantity = quantityInput?.value || fallbackQuantity;

    if (quantityField) quantityField.value = quantity;
    if (quantityText) quantityText.textContent = quantity;
  };

  const openModalAfterResponse = () => {
    const modal = document.querySelector('[data-product-contact-modal] [data-product-contact-open-on-load]')?.closest(
      '[data-product-contact-modal]'
    );

    let pendingProductId = '';
    let pendingSectionId = '';
    let pendingQuantity = '';
    try {
      const pendingValue = sessionStorage.getItem(pendingStorageKey) || '';
      try {
        const pendingContact = JSON.parse(pendingValue);
        if (pendingContact && typeof pendingContact === 'object') {
          pendingProductId = pendingContact.productId || '';
          pendingSectionId = pendingContact.sectionId || '';
          pendingQuantity = pendingContact.quantity?.toString() || '';
        } else {
          pendingProductId = pendingValue;
        }
      } catch (error) {
        // Backwards compatibility with the earlier product-id-only value.
        pendingProductId = pendingValue;
      }
    } catch (error) {
      // Storage may be disabled; server-rendered form state still works.
    }

    const currentUrl = new URL(window.location.href);
    const contactWasPosted = currentUrl.searchParams.get('contact_posted') === 'true';
    const contactWasRequested = currentUrl.searchParams.get('open_contact') === 'true';
    const pendingModal =
      contactWasPosted && pendingProductId
        ? Array.from(document.querySelectorAll('[data-product-contact-modal]')).find(
            (candidate) =>
              candidate.dataset.productId === pendingProductId &&
              (!pendingSectionId || candidate.dataset.sectionId === pendingSectionId)
          )
        : null;
    const requestedModal = contactWasRequested ? document.querySelector('[data-product-contact-modal]') : null;
    const modalToOpen = pendingModal || modal || requestedModal;
    if (!modalToOpen || typeof modalToOpen.show !== 'function') return;

    if (pendingModal && pendingQuantity) {
      const quantityField = pendingModal.querySelector('[data-product-contact-quantity-field]');
      const quantityText = pendingModal.querySelector('[data-product-contact-quantity-text]');
      if (quantityField) quantityField.value = pendingQuantity;
      if (quantityText) quantityText.textContent = pendingQuantity;
    }

    if (pendingModal && !pendingModal.querySelector('[data-product-contact-open-on-load]')) {
      const form = pendingModal.querySelector('[data-product-contact-form]');
      const successMessage = pendingModal.querySelector('[data-product-contact-client-success]');
      if (form && successMessage) {
        Array.from(form.children).forEach((child) => {
          if (child !== successMessage) child.hidden = true;
        });
        successMessage.hidden = false;
      }
    }

    const opener = document.querySelector(`[data-modal="#${modalToOpen.id}"] button`);
    modalToOpen.show(opener || null);

    try {
      sessionStorage.removeItem(pendingStorageKey);
    } catch (error) {
      // Nothing to clean up when storage is unavailable.
    }

    if (contactWasRequested) currentUrl.searchParams.delete('open_contact');
    if (pendingModal) currentUrl.searchParams.delete('contact_posted');

    const query = currentUrl.searchParams.toString();
    window.history.replaceState({}, '', `${currentUrl.pathname}${query ? `?${query}` : ''}${currentUrl.hash}`);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-contact-form]');
    if (!form) return;

    const modal = form.closest('[data-product-contact-modal]');
    if (!modal) return;

    syncModalQuantity(modal);
    const quantity = modal.querySelector('[data-product-contact-quantity-field]')?.value || '1';

    try {
      sessionStorage.setItem(
        pendingStorageKey,
        JSON.stringify({
          productId: modal.dataset.productId || '',
          sectionId: modal.dataset.sectionId || '',
          quantity,
        })
      );
    } catch (error) {
      // The native Shopify form submission does not depend on storage.
    }
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-modal^="#ProductContactModal-"]');
    if (!opener) return;

    const modal = document.querySelector(opener.dataset.modal);
    syncModalQuantity(modal);
  });

  const handleQuantityChange = (event) => {
    if (!event.target.matches('[id^="Quantity-"]')) return;

    const sourceProductInfo = event.target.closest('product-info[data-product-id]');

    document.querySelectorAll('[data-product-contact-modal]').forEach((modal) => {
      const ownsQuantityInput = `Quantity-${modal.dataset.sectionId}` === event.target.id;
      const preferredProductInfo = findProductInfoByProduct(modal.dataset.productId);
      const canSyncByProduct =
        modal.hasAttribute('data-product-contact-sync-by-product') &&
        sourceProductInfo === preferredProductInfo;

      if (canSyncByProduct) modal.dataset.productContactSourceSection = sourceProductInfo.dataset.section;
      if (ownsQuantityInput || canSyncByProduct) syncModalQuantity(modal);
    });
  };

  document.addEventListener('input', handleQuantityChange);
  document.addEventListener('change', handleQuantityChange);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const productId = event?.data?.productId || event?.data?.variant?.product_id?.toString();
      const variant = event?.data?.variant;
      if (!variant) return;

      document.querySelectorAll('[data-product-contact-modal]').forEach((modal) => {
        const isOwnedBySection = modal.dataset.sectionId === sectionId;
        const preferredProductInfo = findProductInfoByProduct(modal.dataset.productId);
        const canSyncByProduct =
          modal.hasAttribute('data-product-contact-sync-by-product') &&
          productId &&
          modal.dataset.productId === productId &&
          preferredProductInfo?.dataset.section === sectionId;

        if (canSyncByProduct) modal.dataset.productContactSourceSection = sectionId;
        if (isOwnedBySection || canSyncByProduct) {
          updateModalVariant(modal, variant);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openModalAfterResponse, { once: true });
  } else {
    openModalAfterResponse();
  }
})();
